export const getMethodBadge = (value: string) => {
  switch (value) {
    case "no-verifier":
      return { text: "Insecure", variant: "warning" as const };
    case "arcade-session":
      return { text: "Development", variant: "secondary" as const };
    case "custom-verifier":
      return { text: "Public", variant: "success" as const };
    default:
      return null;
  }
};

export const getVerificationMethodTitle = (verifierType: string) => {
  switch (verifierType) {
    case "no-verifier":
      return "No verifier";
    case "arcade-session":
      return "Arcade.dev users only";
    case "custom-verifier":
      return "Custom user verifier";
    default:
      return "Unknown method";
  }
};

export const getVerificationMethodDescription = (verifierType: string) => {
  switch (verifierType) {
    case "no-verifier":
      return "Don't verify the user's identity.";
    case "arcade-session":
      return "End-users must be invited to this Arcade project and be signed in to Arcade.dev to authorize tools. Best for development and testing.";
    case "custom-verifier":
      return "Share your agents with anyone by using your own authentication page. Best for production.";
    default:
      return "";
  }
};
